import { TextboxMaskedControl } from "@/Common/Components/Inputs/TextboxMaskedControl";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { ResourceProvider } from "@/Common/Resources/StaticResources";

interface IRequestResetPasswordProps {
    popupTitle: string;
    stringProvider?: ResourceProvider;
    errors: string;
    success: boolean;
    currentlyProcessing: boolean;

    onClosePopupCallBack: () => void;
    onResetPassword: (emailAddress: string) => void;

}

class RequestResetPasswordState {
    public isEmailValid: boolean;
    public emailAddress: string;

    public static getDefault(): RequestResetPasswordState {
        const s = new RequestResetPasswordState();
        s.isEmailValid = true;
        s.emailAddress = "";

        return s;
    }
}

class RequestResetPasswordControl extends React.Component<IRequestResetPasswordProps, RequestResetPasswordState> {
    constructor(props: IRequestResetPasswordProps) {
        super(props);

        this.state = RequestResetPasswordState.getDefault();
    }

    public handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>): void {
        if (event.key === "Enter") {
            if (this.state.isEmailValid) {
                this.resetPassword();
            }
        }
    }

    public render(): JSX.Element {
        let width = 550;
        return (
            <div className="popup" style={{ left: "50%", width: width + "px", marginLeft: -width / 2, top: "20%" }}>

                <div className="p-header">
                    <h4>
                        {this.getString(this.props.popupTitle)}
                    </h4>
                </div>

                {!this.props.success && (
                    <div className="p-body">
                        <div>
                            <p>{this.getString("EnterEmailForPasswordResetMessage")}</p>
                        </div>
                        <br />
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 col-center-align">
                                <label className="form-label" style={{ "paddingTop": "6px" }}>{this.getString("EmailLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-10 col-sm-10">
                                <TextboxMaskedControl
                                    isValid={this.state.isEmailValid}
                                    alphanumericIncludesPeriod={false}
                                    id="Email_id"
                                    value={this.state.emailAddress}
                                    onChangeFunction={value => this.onEmailChange(value)}
                                    returnMaskedValue={true}
                                    onKeyDown={event => this.handleKeyDown(event)}
                                    mask={ValidationHelper.GetEmailEditMaskPattern()}
                                    validationErrorMessage={this.getString("InvalidLabel")}
                                    isEmail={true}
                                />
                            </div>
                        </div>
                        {!IsNullOrWhiteSpace(this.props.errors) && (
                            <div className="row">
                                <div className="error-message col-lg-10 col-lg-offset-2 col-md-10 col-md-offset-2 col-sm-10 col-sm-offset-2">
                                    <label className="label-error"> {this.getString(this.props.errors)} </label>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {this.props.success && (
                    <div className="p-body">
                        <div>
                            <label className="label-success"> {this.getString("ResetEmailSent")} </label>
                        </div>
                    </div>
                )}
                <div className="p-footer">
                    {!this.props.success && (
                        <div className="text-right">
                            <button onClick={() => this.props.onClosePopupCallBack()} className="btn btn-default push-right-5">{this.getString("CancelLabel")}</button>
                            <button disabled={this.DisableResetPasswordButton()} onClick={() => this.resetPassword()} className="btn btn-primary">{this.getString("ResetPasswordLabel")}</button>
                        </div>
                    )}

                    {this.props.success && (
                        <div className="text-right">
                            <button onClick={() => this.props.onClosePopupCallBack()} className="btn btn-primary">{this.getString("FinishLabel")}</button>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private IsEmailValid(email: string): boolean {
        if (IsNullOrWhiteSpace(email)) {
            return true;
        }

        return ValidationHelper.isExactMatch(email, ValidationHelper.emailRegex);
    }

    private DisableResetPasswordButton(): boolean {
        return !this.state.isEmailValid
            || IsNullOrWhiteSpace(this.state.emailAddress)
            || this.props.currentlyProcessing;
    }

    // This popup can be called from the LoginPage in which case the cacheStore doesnt exist yet.
    private getString(label: string): string {
        return this.props.stringProvider ?
            this.props.stringProvider.GetString(label) :
            cacheStore.GetString(label);
    }

    private onEmailChange(val: string): void {
        this.mutateState(s => {
            s.emailAddress = val;
            s.isEmailValid = this.IsEmailValid(val);
        });
    }

    private resetPassword(): void {
        this.props.onResetPassword?.(this.state.emailAddress);
    }

    private mutateState(mutation: (s: RequestResetPasswordState) => void, then: () => void = null): void {
        var s = new RequestResetPasswordState();
        mutation(s);
        (then != null) ? this.setState(s, then) : this.setState(s);
    }
}

export { RequestResetPasswordControl };
